//Taking this out of the Folder View as it's just too much for a tab in an item.
//Need to create a Gannt Chart Wizard on it's own page.
import { autoinject, LogManager } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from "core/app-events";
import { Item, ItemType, GanttInfo } from "data/entities/entities";
import { GanttInfoService } from 'data/service/gantt-info-service';
import { EntityController } from 'pages/entity/entity-controller';
import * as $ from "jquery";

@autoinject()
export class Gantt {

	editSettings;
	toolbarSettings;
	selectedItemChangedSubscription: Subscription;
	selectedItem: Item;
	rootGanttItem: Array<GanttInfo> = [];
	rootGanttItemOriginal: any;
	logger = LogManager.getLogger('Gantt');
	ganttControl;
	
	
 

	constructor(private service: GanttInfoService, private eventAggregator: EventAggregator,
		private controller: EntityController	) {
		this.logger.info("constructor");
		this.toolbarSettings = {
			showToolbar: true,
			toolbarItems: ["add", "edit", "delete", "update", "cancel", "expandAll", "collapseAll", "search", "prevTimeSpan", "nextTimeSpan","criticalPath", "excelExport", "pdfExport"]
		};


		this.editSettings = {
			allowEditing: true,
			allowAdding: true,
			allowDeleting: true,
			allowIndent: true,
			editMode: 'cellEditing'
		};

		

	}

	detached() {
		this.logger.info('detached');
		this.selectedItemChangedSubscription.dispose();
	}

	attached() {
		this.logger.info('attached');
		this.selectedItemChangedSubscription = this.eventAggregator.subscribe(AppEvents.SELECTED_ITEM_CHANGED, (data) => this.selectedItemChanged(data));
		this.getData();//Because the first selectedItemChanged events occurs before this attached event fires, so the initial data is empty.
	}


	activate() {
		this.logger.info("activate()");
		//this.getData(1701);
	}

	ganttToolbarClick(args) {
		//commented out as it currently errors out on the server.
		//let baseUrl = "http://js.syncfusion.com/demos/ejServices/";
		//let id = $(args.currentTarget).attr("id");
		//if (id === "GanttContainer_excelExport") {
		//	this.ganttControl(baseUrl + 'api/Gantt/ExcelExport', "", false);
		//	args.cancel = true;
		//}
		//else if (id === "GanttContainer_pdfExport") {
		//	var isChecked = $("#enablePageBreak").ejCheckBox("isChecked");
		//	if (isChecked)
		//		this.ganttControl(baseUrl + "api/Gantt/FitToWidthPdfExport", "", false);
		//	else
		//		this.ganttControl.export(baseUrl + "api/GanttInfo/PdfExport", "", false);
		//	args.cancel = true;
		//}
	}




	selectedItemChanged(data) {
		if (data.newValue) {
			if (this.selectedItem && (data.newValue.id === this.selectedItem.id)) {
				return;
			}
			this.setSelectedItem(data.newValue);
		}
	}


	setSelectedItem(item: Item) {
		this.selectedItem = item;
		this.logger.info("Selected Item Changed" + item.id);
		this.getData();
	}

	async getData() {
		try {
			this.logger.info("Getting Gantt Info");
			if (this.controller.entityId) {
				var result = await this.service.find(this.controller.entityId);
				if (result) {
					if (!Array.isArray(result)) result = [result]
					this.rootGanttItem = result;
					
				}
			}
		}
		catch (error) {
			this.logger.error(error);
		}
	}

	//onRowDragStop(event) {
	//	this.logger.info("onRowDragStop()");
	//}

	//This is the original, but I think is missnamed.  Not tested.
	onGanttEventActionComplete(event) {

		let requestType = event.requestType;

		if (requestType === "recordUpdate") {

			let item = event.item;

			this.service.saveItem(item);

		}

		this.logger.info("onActionComplete()");
	}

	onActionComplete(event) {

		let requestType = event.requestType;

		if (requestType === "recordUpdate") {

			let item = event.item;

			this.service.saveItem(item);

		}

		this.logger.info("onActionComplete()");
	}

	//onEndEdit(event) {
	//	if (event.cancel) {
	//		this.logger.info("Edit Canceled");
	//	}
	//	//Get the field that was updated
	//	let updatedField = event.columnObject.mappingName;

	//	//
	//	let newValue = event.value;

	//	let itemId = event.data.item.id;
		
	//	this.logger.info(updatedField + ":" + newValue);

	//	this.saveFieldEdit(itemId, updatedField, newValue);

		
	//}

	//saveFieldEdit(itemId: number, updatedField: string, value) {
	//	this.service.saveFieldEdit(itemId, updatedField, value);
	//}

	
}